import { useQuery } from "@tanstack/react-query";
import { useApi } from "./api";

export type JourneyState =
  | "day_1"
  | "week_1"
  | "returning"
  | "quiet"
  | "highly_engaged"
  | "active";

export interface JourneyPayload {
  state: JourneyState;
  label: string;
  explanation: string;
  suggestions: Array<{ title: string; link?: string }>;
}

export function useJourneyState() {
  const api = useApi();
  return useQuery({
    queryKey: ["journey-state"],
    queryFn: () => api.get<JourneyPayload>("/journey/state"),
    // 10-min stale time — journey state evolves over days, not seconds.
    staleTime: 10 * 60_000,
  });
}
